import { useState } from "react";
import { createModel } from "hox";
import { TablePaginationConfig } from "antd/es/table";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE, defaultMdCmParam } from "@/utils/constants";
import { ISearchPage } from "@/types/FmsTypes";
import { transPgToPagination } from "../../../../../base/app/appModel";
import {
    IAccountRechargeDetail,
    IAccountRechargeFields, IAccountRechargeSearch, IAccountRechargeSearchParam,
} from "../../../../AccountTypes";
import { accountService } from "../../../../AccountService";
import { useDetailModel } from "../detailModel";
import { useGlobalModel } from "@/model/globalModel";
import { globalPrompt } from "@/components/YhMessage";
import { message } from "antd";
import { convertRes2Blob } from "@/utils/exportFile";

export const useRechargeModel = createModel(function () {
    const initSearchParam: IAccountRechargeSearchParam = {};
    const initDataSource: IAccountRechargeDetail[] = [];
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const { user: { shopCode, userName } } = useGlobalModel();
    const { customerCode } = useDetailModel();

    //查询条件
    const [searchParam, setSearchParam] = useState<IAccountRechargeSearchParam>(initSearchParam);
    //列表数据源
    const [dataSource, setDataSource] = useState<IAccountRechargeDetail[]>(initDataSource);
    //表格选中行Key值
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
    const [selectedData, setSelectedData] = useState<IAccountRechargeDetail>();
    //列表数据源分页参数
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);

    // 充值总额
    const [rechargeAmount, setRechargeAmount] = useState<number>(0)
    const [approvalDrawerVisible, setApprovalDrawerVisible] = useState(false);
    const [loading, setLoading] = useState(false)

    const onSearch = () => {
        loadData({ pageNum: 1 }).then()
    }
    const onReset = () => {
        resetSearchParam()
    }


    const updatePgCfg = (updateParam: TablePaginationConfig) => {
        setPgCfg({ ...pgCfg, ...updateParam })
    }
    const updateSearchParam = (updateParam: IAccountRechargeFields) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }
    const resetSearchParam = () => {
        setSearchParam(initSearchParam);
        setSelectedRowKeys([]);
        loadData(initPgCfg, {})
    }
    const clearSelectData = () => {
        setSelectedRowKeys([]);
        setSelectedData(undefined)
    }
    const loadData = async (page: ISearchPage = initPgCfg, searchValue: IAccountRechargeSearchParam = searchParam) => {
        try {
            setLoading(true)
            const searchParams: IAccountRechargeSearch = {
                ...searchValue,
                statusList: searchValue.statusList as any ?? "0,1,8",
                partnerCode: customerCode,
                shopCode,
                page: {
                    pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
                    pageNum: (page?.current || page?.pageNum) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
                }
            }
            let { retData } = await accountService.rechargePage(searchParams);
            let { retData: totalRetData } = await accountService.rechargeTotalAmount(searchParams)
            const { records, ...pg } = retData;
            setRechargeAmount(totalRetData)
            setPgCfg(transPgToPagination(pg));
            setDataSource(records);
            clearSelectData();
            setLoading(false)
        } catch (error) {
            setLoading(false)
        }
    }

    const onRevocation = () => {
        if (selectedRowKeys && selectedRowKeys.length > 0) {
            if (selectedData?.status !== 0) return message.error("该条记录不可撤回!");
            globalPrompt("modal", {
                title: "警告", type: "warning", text: "是否确认撤回", onOk: async () => {
                    let insertRet = await accountService.rechargeApproval({
                        code: selectedData.code,
                        status: 3,
                        approver: userName,
                    });
                    if (insertRet.success) {
                        message.success("撤回成功!");
                    } else {
                        message.success("撤回失败!" + insertRet.retMsg);
                    }
                    loadData()
                },
                cancelShow: true,
            })
        } else {
            message.error("请选择待审核记录!");
        }

    }
    //充值记录导出
    const billCustomerExport = async () => {
        const searchParams: IAccountRechargeSearch = {
            ...searchParam,
            statusList: searchParam.statusList as any ?? "0,1,8",
            partnerCode: customerCode,
            shopCode,
        }
        let result = await accountService.export(searchParams);
        convertRes2Blob(result);
    }
    return {
        /***field***/
        searchParam,
        dataSource,
        selectedRowKeys,
        pgCfg,
        selectedData,
        rechargeAmount,
        approvalDrawerVisible,
        loading,
        /***method***/
        setDataSource,
        setSelectedRowKeys,
        resetSearchParam,
        updateSearchParam,
        loadData,
        updatePgCfg,
        onSearch,
        onReset,
        setSelectedData,
        setApprovalDrawerVisible,
        onRevocation,
        billCustomerExport,
        setSearchParam,setLoading
    }
});
